export const fromCornerstoneFilter = (list: any) => {
    return list.filter((ele: any) => ele.from_cornerstone === true)
}